<div
    class="ask-polaris-button"
    (click)="onButtonClick()"
    [tp]="TooltipTemplate"
    [tpClassName]="'custom-tooltip'"
    [tpPlacement]="'left'">
    <app-polaris-icon class="polaris-icon"></app-polaris-icon>
</div>
<ng-template #TooltipTemplate>
    <span class="tooltip-text">{{ tooltip }}</span>
</ng-template>